import { FormHelperText, Grid, TextField, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import { VaBackground, VaBackgroundDetailsField } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import { makeDeepCopy } from "utils/updateLocalState";

const DefaultBackgroundQuestions = {
  personal_facts: {
    question:
      "Share 2-3 things about you that a brand might find interesting or useful for content *",
    answer: "",
    field_name: VaBackgroundDetailsField.personal_facts,
  },
  content_type: {
    question:
      "Do you work with brands on influencer partnerships, UGC, or both? If it's both, let us know whether you want pitches to focus on one or include both.",
    answer: "",
    field_name: VaBackgroundDetailsField.content_type,
  },
  content_tone: {
    question:
      "Share 2-3 words to describe the tone you'd like your pitch written in.",
    answer: "",
    field_name: VaBackgroundDetailsField.content_tone,
  },
  why_brands_like_your_content: {
    question:
      "Why do brands like your content? Share what you bring to the table.",
    answer: "",
    field_name: VaBackgroundDetailsField.why_brands_like_your_content,
  },
  most_proud_partnerships: {
    question: "What past partnerships of yours are you most proud of and why?",
    answer: "",
    field_name: VaBackgroundDetailsField.most_proud_partnerships,
  },
  other: {
    question:
      "Anything else you would like to share? Share anything that would help us write unique and curated pitches for you.",
    answer: "",
    field_name: VaBackgroundDetailsField.other,
  },
};

const BackgroundForm = () => {
  const { organizationVaProfile, profile, setProfile } = useContext(
    OrganizationUserContext,
  );
  const background: VaBackground =
    organizationVaProfile?.backgroundDetails ||
    profile?.backgroundDetails ||
    DefaultBackgroundQuestions;

  const onChange = (e: CustomEvent) => {
    const { name, value } = e.target;
    setProfile((prev) => {
      const copy = makeDeepCopy(prev);
      if (!copy.backgroundDetails) {
        copy.backgroundDetails = background;
      }
      copy.backgroundDetails[name]["answer"] = value;
      return copy;
    });
  };

  const renderBackgroundQuestion = (
    fieldName: VaBackgroundDetailsField,
    rows?: number,
  ) => {
    return (
      <Grid item xs={12}>
        <FormHelperText>{background?.[fieldName]?.question}</FormHelperText>
        <TextField
          sx={{
            backgroundColor: "white",
            "& .MuiInputBase-root": { backgroundColor: "white" },
            "& .MuiFormHelperText-root": { color: "error.main" },
            mb: 2,
          }}
          fullWidth
          name={fieldName}
          placeholder={"Type your answer here..."}
          onChange={onChange}
          value={background?.[fieldName]?.answer}
          multiline
          rows={rows || 3}
          required={fieldName === VaBackgroundDetailsField.personal_facts}
        />
      </Grid>
    );
  };

  return (
    <>
      <Typography sx={{ mb: 2 }}>
        <strong>
          ❗ Don't worry about how you write things; we use copywriters to make
          everything sound polished. Feel free to ramble, write in bullet
          points, or write an essay. It's better to write more than less.{" "}
        </strong>
      </Typography>

      {Object.keys(background || {}).map((fieldName) => {
        return renderBackgroundQuestion(
          fieldName as VaBackgroundDetailsField,
          fieldName === VaBackgroundDetailsField.other ? 6 : 3,
        );
      })}
    </>
  );
};

export default BackgroundForm;
